import { useState, useEffect, useCallback } from "react";
import api from "../lib/api";

export function useSubscriptionLimits(vendorId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [limitError, setLimitError] = useState(null);

  const fetch = useCallback(async () => {
    if (!vendorId) { setLoading(false); return; }
    try {
      setLoading(true);
      const { data: res } = await api.get('/super-admin/plan-status');
      setData(res);
    } catch (err) {
      setLimitError(err?.message || 'Failed to load plan status');
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  useEffect(() => { fetch(); }, [fetch]);

  const limits = data?.subscription || null;
  const usage = data?.usage || { branches: 0, members: 0, staff: 0, trainers: 0 };
  const planName = data?.subscription?.plan_name || '';
  const subscription = data?.subscription || null;

  const checkLimit = useCallback(
    (type) => {
      if (!limits) return null;
      const max = limits[`max_${type}`];
      if (max === -1) return null;
      const current = usage[type] ?? 0;
      if (current >= max) {
        const labelMap = { branches: 'branches', members: 'members', staff: 'staff members', trainers: 'trainers' };
        return `You've reached your ${planName} plan limit of ${max} ${labelMap[type] || type}. Upgrade your plan to add more.`;
      }
      return null;
    },
    [limits, usage, planName]
  );

  return { limits, usage, planName, subscription, loading, limitError, refetch: fetch, checkLimit };
}
